import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { MdKeyboardDoubleArrowRight, MdKeyboardArrowLeft } from "react-icons/md";
import { ToastContainer } from 'react-toastify';
import imgProfile from '../../assets/android-chrome-512x512.png'

function ViewTournament() {
  const navigate = useNavigate() 


  return (
    <>
      <ToastContainer autoClose={2000} position="top-center" />
      <div className="">
        <div className="row mx-4">
          <div className='d-flex align-items-center justify-content-between p-0'>
            <h4 className="header-title mb-0 text-muted mt-3">
              <Link onClick={() => navigate(-1)} className="header-sub-title">
                All Tournament
              </Link>
              <span className="blr-player-view">
                <MdKeyboardDoubleArrowRight className='jumbo-red-text mb-1 ms-2 '/>
              </span>{" "}
              View Tournament
            </h4>
            <button
              type='button'
              className='btn text-white mt-3 d-flex'
              onClick={() => navigate(-1)}
            >
              <MdKeyboardArrowLeft className='fs-4' />
              Back
            </button>
          </div> 
            <div className="card  col-12 col-md-4 col-lg-3 mb-0 mt-3 " style={{height:'375px'}}>
              <div className="card-body d-flex flex-column align-items-center justify-content-center ">
                <div className="blr-img-league  ">
                  <img
                    src={imgProfile}
                    alt="Profile"
                    className="img-fluid" 
                  />
                  <h4 className="pt-3 text-center"> Premier League</h4>
                </div>
              </div>
            </div> 
          <div className="col-12 col-md-8 col-lg-9 my-3 pe-0">
            <div className="card">
              <div className="card-body">
                <div className="responsive-table p-1" style={{border:'1px solid var(--bs-border-color)',borderRadius:'10px'}}>
                  <table className='table w-100 nowrap mb-0'>
                    <tbody>
                      <tr>
                        <th className='pb-3 w-25'>Known Name</th>
                        <td className='pb-3'>:</td>
                        <td className='pb-3'>Premier League</td>
                      </tr>
                      <tr>
                        <th className='pb-3'>Code</th>
                        <td className='pb-3'>:</td>
                        <td className='pb-3'>Club </td>
                      </tr>
                      <tr>
                        <th className='pb-3'>Order</th>
                        <td className='pb-3'>:</td>
                        <td className='pb-3'>1</td>
                      </tr>
                      <tr>
                        <th className='pb-3'>Format</th>
                        <td className='pb-3'>:</td>
                        <td className='pb-3'>Domestic league</td>
                      </tr>
                      <tr>
                        <th className='pb-3'>Country</th>
                        <td className='pb-3'>:</td>
                        <td className='pb-3'>England </td>
                      </tr>
                      <tr>
                        <th className='pb-3'>Type</th>
                        <td className='pb-3'>:</td>
                        <td className='pb-3'>men</td>
                      </tr>
                      <tr>
                        <th className='pb-3 border-0 text-nowrap'>Competition Type</th>
                        <td className='pb-3 border-0'>:</td>
                        <td className='pb-3 border-0'>abcd</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>  
          </div>
        </div>
      </div>
    </>
  )
}

export default ViewTournament
